import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MenuAction } from "src/app/models/menuAction.model";

@Component({
    selector: "app-single-page-actions",
    templateUrl: "./single-page-actions.component.html",
    styleUrls: ["./single-page-actions.component.scss"],
})
export class SinglePageActionsComponent {
    @Input() public menuActions: MenuAction[];
    @Output() public actionSelected = new EventEmitter<string>();

    public isMenuOpen = false;

    public actionOnClick(action: MenuAction) {
        this.isMenuOpen = false;

        this.actionSelected.emit(action.name);
    }

    public onMenuClick = () => (this.isMenuOpen = !this.isMenuOpen);

    public onOutsideMenuClick = () => (this.isMenuOpen = false);
}
